import { render, staticRenderFns } from "./tipControl.vue?vue&type=template&id=b1935846&scoped=true&"
import script from "./tipControl.vue?vue&type=script&lang=js&"
export * from "./tipControl.vue?vue&type=script&lang=js&"
import style0 from "./tipControl.vue?vue&type=style&index=0&id=b1935846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1935846",
  null
  
)

component.options.__file = "tipControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VSelect,
  VTextField,
})
